import React from 'react';
import { STATS } from '../mock';

export default function Stats() {
  return (
    <section className="py-20 md:py-28 border-b border-black/10">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
        {STATS.map((s) => (
          <div key={s.label} className="flex flex-col">
            <div className="num-font text-5xl md:text-6xl text-black">{s.value}</div>
            <div className="mono-font mt-4 text-black/50">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
